<template>
  <b-datepicker
    icon="calendar-today"
    :value="selectedDate"
    :max-date="maxDate"
    :min-date="minDate"
    @input="onInput"
    :placeholder="placeholder"
  ></b-datepicker>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: String
    },

    placeholder: {
      type: String
    },

    limit: {
      type: String
    },
  },

  computed: {
    minDate() {
      return new Date(this.limit);
    },

    maxDate() {
      return this.addMonths(new Date(this.limit), '3');
    },

    selectedDate() {
      if (this.value) {
        return new Date(this.value);
      }

      return null;
    }
  },

  methods: {
    onInput(value) {
      let date = moment(value).format("YYYY-MM-DD");
      this.$emit("input", date);
    },

    addMonths(date, months) {
      var d = date.getDate();
      date.setMonth(date.getMonth() + +months);
      if (date.getDate() !== d) {
        date.setDate(0);
      }
      return date;
    },
  }
};
</script>
